import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowIcon } from '../../assets/icons/down-arrow.svg';

type Option = {
  value: string | number;
  label: string;
};

interface SelectFieldProperties {
  inputLabel?: string;
  options: Option[]; // Array of objects with value and label
  placeholder?: string;
  selectedValue: string | number;
  name: string;
  svgIcon?: JSX.Element;
  onChangeValue: (name: string, value: any) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
}

/**
 * Shared select field
 */
function DefaultSelectField({
  inputLabel,
  options,
  name,
  placeholder,
  svgIcon,
  selectedValue,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
}: SelectFieldProperties) {
  /**
   * Function to handle selection change
   */
  const handleValueChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChangeValue(name, event?.target?.value);
  };
  const { i18n } = useTranslation();

  return (
    <div className="default-select-wrap" dir={i18n.dir()}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className={`default-select-container ${error && 'error'}`}>
        {svgIcon && <span className="frond-icon">{svgIcon}</span>}
        <select value={selectedValue} onChange={handleValueChange}>
          {placeholder && (
            <option value="" disabled selected>
              {placeholder}
            </option>
          )}
          {options?.map((option) => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
        <span className="custom-icon">
          <ArrowIcon />
        </span>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

DefaultSelectField.defaultProps = {
  inputLabel: '',
  placeholder: '',
  valueRequired: false,
  error: false,
  svgIcon: null,
  errorMessage: '',
};

export default DefaultSelectField;
